import { defineMessages } from 'react-intl';

export const ACTION_BUTTON_MINWIDTH = '120px';

export const messages = defineMessages({
  cancel: {
    defaultMessage: 'Cancel',
    id: 'Dialog.cancel',
  },
  confirm: {
    defaultMessage: 'OK',
    id: 'Dialog.confirm',
  },
});
